export default "/images/team-spirit.webp?e3dd2e5815e5f4bbe76a08a1c3c37dc6";